// Добавляет обработку жестов свайпа на элементе

/**
 * Добавляет обработку жестов свайпа на элементе
 * 
 * @param element Элемент, на котором будут обрабатываться жесты
 * @param listeners Объект обработчиков событий Свайпа
 * @param mouse Обрабатывать жесты мыши?
 */
function addSwipeEventListeners( element: Element, listeners: SwipeEventListeners, mouse: boolean = true ): void
{
	let startX: number = 0;
	let startY: number = 0;
	let endX: number = 0;
	let endY: number = 0;
	
	element.addEventListener(
		'touchstart',
		( event: TouchEvent ): void =>
		{
			startX = event.changedTouches[0].screenX;
			startY = event.changedTouches[0].screenY;
		},
	);
	element.addEventListener(
		'touchend',
		( event: TouchEvent ): void =>
		{
			endX = event.changedTouches[0].screenX;
			endY = event.changedTouches[0].screenY;
			handleGesture( startX, startY, endX, endY, listeners );
		},
	);
	
	if ( mouse )
	{
		element.addEventListener(
			'mousedown',
			( event: MouseEvent ): void =>
			{
				startX = event.clientX;
				startY = event.clientY;
			},
		);
		element.addEventListener(
			'mouseup',
			( event: MouseEvent ): void =>
			{
				endX = event.clientX;
				endY = event.clientY;
				handleGesture( startX, startY, endX, endY, listeners );
			},
		);
	}
}

/**
 * Определение жеста
 * 
 * @param startX Координата X начала жеста
 * @param startY Координата Y начала жеста
 * @param endX Координата X окончания жеста
 * @param endY Координата Y окончания жеста
 * @param listeners Объект обработчиков событий Свайпа
 */
function handleGesture( startX: number, startY: number, endX: number,
	endY: number, listeners: SwipeEventListeners ): void
{
	if (
		listeners.up
		&& ( endY > startY )
	)
	{
		listeners.up();
	}
	if (
		listeners.down
		&& ( endY < startY )
	)
	{
		listeners.down();
	}
	if (
		listeners.left
		&& ( endX < startX )
	)
	{
		listeners.left();
	}
	if (
		listeners.right
		&& ( endX > startX )
	)
	{
		listeners.right();
	}
	if (
		listeners.tap
		&& ( endY === startY )
	)
	{
		listeners.tap();
	}
}

/**
 * Объект обработчиков событий Свайпа
 */
interface SwipeEventListeners
{
	/** Свайп вверх */
	up?(): void;
	/** Свайп вниз */
	down?(): void;
	/** Свайп влево */
	left?(): void;
	/** Свайп вправо */
	right?(): void;
	/** Прикосновение */
	tap?(): void;
}

/**
 * Module
 */
export {
	addSwipeEventListeners as default,
	SwipeEventListeners,
};



// WEBPACK FOOTER //
// ./app/utils/addSwipeEventListeners.ts